import { Link } from "react-router-dom";
import { latestChapters } from "@/mocks/manga";

const badgeClass: Record<string, string> = {
  单行本: "bg-primary-100 text-primary-700",
  连载: "bg-accent-100 text-accent-700",
  全彩: "bg-secondary-200 text-secondary-800",
  番外: "bg-primary-100 text-primary-700",
};

export default function Chapters() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">最新更新</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">近期热门章节</h2>
          </div>
          <Link
            to="/catalog"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            更多章节
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {latestChapters.map((c) => (
            <Link
              key={c.id}
              to={`/read/${c.id}`}
              className="group flex items-center gap-4 rounded-2xl bg-background-100 p-4 transition-colors hover:bg-primary-100/70"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-xl"></i>
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-semibold ${badgeClass[c.category]}`}>
                    {c.category}
                  </span>
                  <span className="text-xs text-foreground-500">{c.volume}</span>
                </div>
                <h3 className="mt-1 truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                  {c.title}
                </h3>
              </div>
              <i className="ml-auto ri-arrow-right-s-line text-xl text-foreground-400"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}